<template>
  <div class="agricultureProducts-page">
    <el-tabs v-model="countryside">
      <el-tab-pane label="本地区整体" name="whole">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.endTime" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40 padding-t-30">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="wholeOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="border-DEDEDE colorChang">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1.农产品指种植业、畜牧业、水产养殖业等通过自然生长或人工培育的未经过加工的初级产品或者经过初级加工的产品。
          <br/>2.根据商务部标准，农产品划分为粮油、肉禽蛋、水产品、蔬菜、水果、豆制品、休闲食品、滋补食品、调味品、奶类、茶叶11个一级类目、88个二级类目。
        </p>
      </el-tab-pane>
      <el-tab-pane label="商品大类" name="goodsCategory">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="goodsCategoryForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="goodsCategoryForm.way" @change="getGoodsCategory">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="2"  style="width: 125px">
                <span :class="goodsCategoryTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="oneMonth('goodsCategory')">近1个月</span>
                <span :class="goodsCategoryTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <el-col :span="4">
                <el-date-picker v-model="goodsCategoryForm.endTime" placeholder="选择日期" type="month" @change="getGoodsCategory(cityTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="oneTierOptions" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="oneTierTable" stripe height="400" class="float-left border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
<!--                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>-->
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="twoTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="twoTierTable" height="400" stripe class="border-DEDEDE colorChang">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
<!--        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">-->
<!--          <el-row>-->
<!--            <el-col :span="13">-->
<!--              <chart ref="chart1" :options="threeTierOptions" autoresize class="width-z100"></chart>-->
<!--            </el-col>-->
<!--            <el-col :span="10" class="margin-l-30">-->
<!--              <el-table :data="threeTierTable" height="400" stripe class="border-DEDEDE colorChang">-->
<!--                <el-table-column prop="times" label="时间" align="center"></el-table-column>-->
<!--                <el-table-column prop="absoulte_key" label="行业" width="158" align="center"></el-table-column>-->
<!--                <el-table-column prop="absoulte_value" label="网络零售额（元）" align="center"></el-table-column>-->
<!--              </el-table>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-card>-->
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：
          1.农产品指种植业、畜牧业、水产养殖业等通过自然生长或人工培育的未经过加工的初级产品或者经过初级加工的产品。
          2.根据商务部标准，农产品划分为粮油、肉禽蛋、水产品、蔬菜、水果、豆制品、休闲食品、滋补食品、调味品、奶类、茶叶11个一级类目、88个二级类目。
        </p>
      </el-tab-pane>
      <el-tab-pane label="交易渠道" name="platform">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="transactionForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="transactionForm.way" @change="getTransactionList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="oneMonth('transaction')" v-if="transactionForm.resource == '1'">近1个月</span>
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="twelveMonth('transaction')" v-if="transactionForm.resource == '2'">近13个月</span>
                <span
                  :class="transactionTime=='2'?'cursor-pointer text-1E88E5 text-content':' cursor-pointer text-content'"
                  @click="transactionTime = 2">月度</span>
              </el-col>
              <el-col :span="4" v-if="transactionForm.resource == '2'">
                <el-date-picker v-model="transactionForm.startTime" type="month" @change="getTransactionList(transactionTime = 2)"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1" v-if="transactionForm.resource == '2'">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="transactionForm.endTime" type="month" v-if="transactionForm.resource == '2'"
                                @change="getTransactionList(transactionTime = 2)" :picker-options="pickerOptions"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
                <el-date-picker v-model="transactionForm.endTime" v-if="transactionForm.resource == '1'" type="month"
                                @change="getTransactionList(transactionTime = 2)" :picker-options="pickerOptions"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>

              </el-col>
            </el-form-item>
            <el-form-item label="平台：">
              <el-radio-group v-model="transactionForm.resource" class="margin-r-20" @change="tranResource()">
                <el-radio label="1">全平台</el-radio>
                <el-radio label="2">单平台</el-radio>
              </el-radio-group>
              <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"
                         :disabled="transactionForm.resource=='1'" @change="getTransactionList()">
                <el-option v-for="platform in platformList" :label=platform.platform :value=platform.platform :key="platform.id"
                           class=""></el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getTransactionList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-row v-if="transactionForm.resource == '1'" class="margin-l-30  margin-t-20 margin-r-30">
          <el-col :span="12">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>

          </el-col>
          <el-col :span="12" class="padding-l-20">
            <el-card>
              <el-table :data="transactionTable" stripe height="400" class="border-DEDEDE">
                <el-table-column prop="ext" label="排名" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="交易平台" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>
        <el-row v-if="transactionForm.resource == '2'" class="margin-l-30 margin-r-30 margin-t-20">
          <el-col :span="13">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>
          </el-col>
          <el-col :span="11" class="padding-l-20">
            <el-card>
              <el-table :data="singleTransactionTable" stripe height="400" class="border-DEDEDE">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
      <!--      <el-tab-pane label="排行榜" name="rank">-->
      <!--        <el-card class="margin-l-30 text-left margin-r-30">-->
      <!--          <el-form ref="form" :model="allForm" label-width="80px">-->
      <!--            <el-form-item label="时间：">-->
      <!--              <el-date-picker v-model="allForm.times" placeholder="选择日期" type="month"-->
      <!--                              size="small" format="yyyy-MM"  :clearable="false"-->
      <!--                              value-format="yyyy-MM" @change="getAllRank(wholeTime = 2)"></el-date-picker>-->
      <!--            </el-form-item>-->
      <!--          </el-form>-->
      <!--        </el-card>-->
      <!--        <el-row class="margin-l-30  margin-t-20">-->
      <!--          <el-col :span="12">-->
      <!--            <el-card>-->
      <!--              <div slot="header" class="index-header">-->
      <!--                <div class="float-left">企业排行榜</div>-->
      <!--                <div class="float-right">-->
      <!--                  <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"-->
      <!--                             @change="getCompanyRank()">-->
      <!--                    <el-option label="全平台" value="全平台" class=""></el-option>-->
      <!--                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>-->
      <!--                    <el-option label="京东商城" value="京东商城" class=""></el-option>-->
      <!--                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>-->
      <!--                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>-->
      <!--                    &lt;!&ndash;                    <el-option label="国美在线" value="国美在线" class=""></el-option>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                    <el-option label="当当网" value="当当网" class=""></el-option>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                    <el-option label="亚马逊(中国)" value="亚马逊(中国)" class=""></el-option>&ndash;&gt;-->
      <!--                  </el-select>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <el-table :data="companyRank" stripe height="400" class="border-DEDEDE"-->
      <!--                        :default-sort="{prop: 'simple', order: 'descending'}">-->
      <!--                <el-table-column type="index" label="排名" width="50" align="center">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column prop="name" label="企业名称"></el-table-column>-->
      <!--                <el-table-column prop="area" label="工商注册地" width="118"></el-table-column>-->
      <!--                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>-->
      <!--              </el-table>-->
      <!--            </el-card>-->
      <!--          </el-col>-->
      <!--          <el-col :span="11" class="margin-l-30">-->
      <!--            <el-card>-->
      <!--              <div slot="header" class="index-header">-->
      <!--                <div class="float-left">企业店铺榜</div>-->
      <!--                <div class="float-right">-->
      <!--                  <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"-->
      <!--                             @change="getCompanyShopRank()">-->
      <!--                    <el-option label="全平台" value="全平台" class="" checked="checked" :key="item.value1"></el-option>-->
      <!--                    <el-option label="天猫商城" value="天猫商城" class=""></el-option>-->
      <!--                    <el-option label="京东商城" value="京东商城" class=""></el-option>-->
      <!--                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>-->
      <!--                    <el-option label="苏宁易购" value="苏宁易购" class=""></el-option>-->
      <!--                    &lt;!&ndash;                    <el-option label="国美在线" value="国美在线" class=""></el-option>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                    <el-option label="当当网" value="当当网" class=""></el-option>&ndash;&gt;-->
      <!--                  </el-select>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <el-table :data="companyShopRank" stripe height="400" class="border-DEDEDE"-->
      <!--                        :default-sort="{prop: 'simple', order: 'descending'}">-->
      <!--                <el-table-column type="index" label="排名" width="50" align="center">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column prop="name" label="店铺名称"></el-table-column>-->
      <!--                <el-table-column prop="area" label="店铺所在地" width="158"></el-table-column>-->
      <!--                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>-->
      <!--              </el-table>-->
      <!--            </el-card>-->

      <!--          </el-col>-->
      <!--        </el-row>-->
      <!--        <el-row class="margin-l-30  margin-t-20">-->
      <!--          <el-col :span="12">-->
      <!--            <el-card>-->
      <!--              <div slot="header" class="index-header">-->
      <!--                <div class="float-left">个人店铺榜</div>-->
      <!--                <div class="float-right">-->
      <!--                  <el-select v-model="personalShopForm.platform" placeholder="请选择" size="small"-->
      <!--                             @change="getPersonalShopRank()">-->
      <!--                    <el-option label="淘宝网" value="淘宝网" class=""></el-option>-->
      <!--                  </el-select>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <el-table :data="personalShopRank" stripe height="400" class="border-DEDEDE"-->
      <!--                        :default-sort="{prop: 'simple', order: 'descending'}">-->
      <!--                <el-table-column type="index" label="排名" width="50" align="center">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column prop="name" label="店铺名称"></el-table-column>-->
      <!--                <el-table-column prop="area" label="店铺所在地" width="158"></el-table-column>-->
      <!--                <el-table-column prop="absolute_value" label="网络零售额（万元）" align="center"></el-table-column>-->
      <!--              </el-table>-->
      <!--            </el-card>-->
      <!--          </el-col>-->
      <!--          <el-col :span="11" class="margin-l-30">-->
      <!--            <el-card>-->
      <!--              <div slot="header" class="index-header">-->
      <!--                <div class="float-left">地市排行榜</div>-->
      <!--              </div>-->
      <!--              <el-table :data="cityRank" stripe height="400" class="border-DEDEDE"-->
      <!--                        :default-sort="{prop: 'simple', order: 'descending'}">-->
      <!--                <el-table-column type="index" label="排名" width="50" align="center">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column prop="city" label="地市" width="158"></el-table-column>-->
      <!--                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>-->
      <!--              </el-table>-->
      <!--            </el-card>-->
      <!--          </el-col>-->
      <!--        </el-row>-->

      <!--      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'agricultureProducts',
    data () {
      return {
        countryside: 'whole',
        wholeForm: {way: '当期网络零售额', startTime: '', endTime: '', type: 1},//整体情况筛选条件
        wholeOptions: {}, //整体情况图表
        wholeTable: [],
        wholeTime: '1',

        goodsTypeForm: {way: '当期网络零售额', startTime: '', endTime: '', type: 1},//整体情况筛选条件
        goodsTypeOptions: {}, //整体情况图表
        goodsTypeTable: [],
        goodsTypeTime: '1',

        transactionForm: {way: '当期网络零售额', startTime: '', endTime: '', platform: '全平台',resource:'1'},//交易平台筛选条件
        transactionPie: {}, //平台图表
        transactionTable: [],
        singleTransactionTable: [],//单平台表格
        platformList: [],

        transactionTime: '1',
        goodsCategoryForm: {way: '当期网络零售额', startTime: '', endTime: '', type: 1},//整体情况筛选条件
        oneTierOptions: {}, //一级行业网络零售额图表
        twoTierOptions: {}, //二级行业网络零售额图表
        threeTierOptions: {}, //三级行业网络零售额图表
        oneTierTable: [],//一级行业表格
        twoTierTable: [],//二级行业表格
        threeTierTable: [],//三级行业表格
        goodsCategoryTime: '1',

        allForm: {times: ''},//

        cityCategoryOptions:{},//地区选择实物当期图表
        cityCategoryTable:[],
        form: {},
        wholeTitle: '',
        wholeList: {xTime: [], yTotalmoney: [], simple: []},



        cityCategory: [],//示范县分地区筛选类型
        cityType:'',//默认选中第一个示范县
        districtType:'',
        cityOptions: {},//地区类型柱图
        cityTable:[],
        cityTime: '1',
        cityList: [],
        areaList: [],
        cityTitle: '',
        cityForm: {way: '当期网络零售额', area: '1', startTime: '', endTime: ''},//地区类型筛选条件

        productTime: '1',
        productForm: {way: '1', endTime: ''}, //商品大类筛选条件

        //表格数据

        productTwoTable: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.getPlatform()
      this.twelveMonth()
      this.oneMonth()
    },
    methods: {

      //整体情况列表
      getWholeList () {
        this.$http.get(this.header + '/farmPorducts/xyWhole', {
          params: {
            index_type: this.wholeForm.way,
            sMonth: this.wholeForm.startTime,
            eMonth: this.wholeForm.endTime,
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.wholeList = {xTime: [], yTotalMoney: [], simple: []}

            res.data.monthList.forEach((y, index) => {
              this.wholeList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: y.absoulte_key
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              this.wholeList.yTotalMoney.push(yMoney)
              // this.wholeList.yTotalMoney.unit.push('万元')
              this.wholeList.simple.push(xSimple)
            })
            this.wholeTable = res.data.monthList.reverse()
            let Min1 = this.calMin(this.wholeList.yTotalMoney), Min2 = this.calMin(this.wholeList.simple),
              Max1 = this.calMax(this.wholeList.yTotalMoney), Max2 = this.calMax(this.wholeList.simple)
            //整体情况图表
            this.wholeOptions = {
              title: {//图表标题
                text: '农产品' + this.wholeForm.way + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom:1000
                },
              },
              toolbox: { //图表工具箱
                feature: {
                  magicType: {show: true, type: ['line', 'bar']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['网络零售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: this.wholeList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  min: Min1,
                  max: Max1,
                  splitNumber: 5,
                  interval: (Max1 - Min1) / 5,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }, {
                  type: 'value',
                  name: '%',
                  min: Min2,
                  max: Max2,
                  splitNumber: 5,
                  interval: (Max2 - Min2) / 5,
                  // axisLabel: {
                  //   formatter: '{value} %'
                  // },
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }],
              series: [{
                name: '网络零售额',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: '#7888ed'
                  },
                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: this.wholeList.yTotalMoney,
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle:{
                  normal:{
                    color:'#FB975B'
                  }
                },
                data: this.wholeList.simple
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //商品大类列表
      getGoodsCategory () {
        this.$http.get(this.header + '/farmPorducts/goodsIndustry', {
          params: {
            index_type: this.goodsCategoryForm.way,
            times: this.goodsCategoryForm.endTime,
          }
        }).then(res => {
          if (res.data.code == 0) {
            let oneTierList = {xName: [], yTotalMoney: []}
            //一级行业图表
            res.data.oneTier.forEach((y, index) => {
              oneTierList.xName.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              oneTierList.yTotalMoney.push(yMoney)
            })
            this.oneTierTable = res.data.oneTier.reverse()
            let Min1 = this.calMin(oneTierList.yTotalMoney), Max1 = this.calMax(oneTierList.yTotalMoney)
            //一级行业图表

            this.oneTierOptions = {
              title: {//图表标题
                text: '农产品实物一级行业'+this.goodsCategoryForm.way,
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              grid: {
                left: '6%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 万元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '万元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                min: 0,
                max: Max1,
                splitNumber: 5,
                interval: (Max1 - 0) / 5,
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: oneTierList.xName
              },
              // dataZoom: [{
              //   type: 'slider',//图表下方的伸缩条
              //   yAxisIndex: [0],
              //   left: 'left',
              //   show: true, //是否显示
              //   realtime: true, //拖动时，是否实时更新系列的视图
              //   start: 50, //伸缩条开始位置（1-100），可以随时更改
              //   end: 100, //伸缩条结束位置（1-100），可以随时更改
              // }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      var colorList = ['#4c83d2']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 1]
                    }
                  },
                  emphasis: {
                    color: '#7ba9eb'
                  }
                },
                data: oneTierList.yTotalMoney,
              }]
            }
            //二级行业图表
            let twoTierList = {xName: [], yTotalMoney: []}
            res.data.twoTier.forEach((y, index) => {
              twoTierList.xName.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              twoTierList.yTotalMoney.push(yMoney)
            })
            this.twoTierTable = res.data.twoTier.reverse()
            let twoTierMax1 = this.calMax(twoTierList.yTotalMoney)
            this.twoTierOptions = {
              title: {//图表标题
                text: '农产品实物二级类目'+this.goodsCategoryForm.way,
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              grid: {
                left: '6%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 万元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '万元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                min: 0,
                max: twoTierMax1,
                splitNumber: 5,
                interval: (twoTierMax1 - 0) / 5,
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: twoTierList.xName
              },
              dataZoom: [{
                type: 'slider',//图表下方的伸缩条
                yAxisIndex: [0],
                left: 'left',
                show: true, //是否显示
                realtime: true, //拖动时，是否实时更新系列的视图
                start: 50, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
              }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      var colorList = ['#8a98e8']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 1]
                    }
                  },
                  emphasis: {
                    color: '#aab7ff'
                  }
                },
                data: twoTierList.yTotalMoney,
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //交易平台
      getTransactionList () {
        this.$http.get(this.header + '/farmPorducts/cannal', {
          params: {
            index_type: this.transactionForm.way,
            sMonth: this.transactionForm.startTime,
            eMonth: this.transactionForm.endTime,
            platform: this.transactionForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.transactionTable = res.data.list

            let platform = res.data.list
            if (this.transactionForm.resource == '1') {
              let transactionList = {xName: [], transactionData: []}
              res.data.list.reverse().forEach((y, index) => {
                transactionList.xName.push(y.absoulte_key)
                let yMoney = {
                  value: y.absoulte_value,
                  unit: '万元'
                }
                transactionList.transactionData.push(yMoney)
              })
              this.transactionTable = res.data.list.reverse()
              this.transactionPie = {
                title: {//图表标题
                  text: '各交易平台' + this.transactionForm.way + '分析',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300,
                    marginBottom: 1000
                  },
                },
                grid: {
                  left: '6%',
                  // right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: '{b}网络零售额<br/>{c} 万元'
                },
                toolbox: { //图表工具箱
                  feature: {
                    // dataView: {show: true, readOnly: false},
                    magicType: {show: true, type: ['line', 'bar']},
                    // restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                xAxis: {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                },
                yAxis: {
                  type: 'category',
                  // axisLabel: {'interval': 0, rotate: 40},
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  data: transactionList.xName
                },
                // dataZoom: [{
                //   type: 'slider',//图表下方的伸缩条
                //   yAxisIndex: [0],
                //   left: 'left',
                //   show: true, //是否显示
                //   realtime: true, //拖动时，是否实时更新系列的视图
                //   start: 50, //伸缩条开始位置（1-100），可以随时更改
                //   end: 100, //伸缩条结束位置（1-100），可以随时更改
                // }],
                series: [{
                  name: '月份',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        var colorList = ['#8a98e8']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 1]
                      }
                    },
                    emphasis: {
                      color: '#aab7ff'
                    }
                  },
                  data: transactionList.transactionData,
                }]
              }
            } else {

              let data = []
              let compare = []
              let time = []
              platform.forEach((y, index) => {
                time.push(y.month)
                let ypro = {
                  value: y.absoulte_value_pro,
                  unit: '%'
                }
                let yvalue = {
                  value: y.absoulte_value,
                  unit: '万元'
                }
                compare.push(ypro)
                data.push(yvalue)
              })
              this.singleTransactionTable = res.data.list.reverse()
              this.transactionPie = {
                title: {//图表标题
                  text: this.transactionForm.platform + this.transactionForm.way + '变化趋势',
                  left: 'center',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300,
                    marginBottom: 1000
                  },
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  data: ['零售额', '占比']
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                xAxis: {
                  type: 'category',
                  data: time
                },
                yAxis: [{
                  type: 'value',
                  name: '万元',
                }, {
                  type: 'value',
                  name: '%',
                  // min: 0,
                  // max: 35,
                  // interval: 5,
                  splitLine:{//去除网格线
                    show:false
                  },
                  axisLabel: {
                    formatter: '{value} %'
                  }
                }],
                series: [{
                  name: '零售额',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed'
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data: data,
                }, {
                  name: '占比',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle:{
                    normal:{
                      color:'#FB975B'
                    }
                  },
                  data: compare
                }]
              }
            }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取交易平台列表
      getPlatform () {
        this.$http.get(this.header + '/farmPorducts/getPlatform').then(res => {
          if (res.data.code == 0) {
            this.platformList = res.data.platform
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      tranResource () {
        if (this.transactionForm.resource == '1') {
          this.transactionForm.platform = '全平台'
          this.transactionForm.startTime = ''
          this.getTransactionList()
        } else {
          this.transactionForm.platform = '京东商城'
          this.twelveMonth('transaction')
          // this.getTransactionList()
        }
      },
      getAllRank () {
        this.getBrandRank()
        this.getCompanyShopRank()
        this.getSpuRank()
        this.getCompanyRank()
      },
      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          if(val == 'transaction'){
            this.transactionTime = '1'
            this.transactionForm.startTime = dataArr[13]
            this.transactionForm.endTime = dataArr[1]
            this.getTransactionList()
          } else {
            this.wholeTime = '1'
            this.wholeForm.startTime = dataArr[13]
            this.wholeForm.endTime = dataArr[1]
            this.getWholeList()
            this.transactionTime = '1'
            this.transactionForm.startTime = dataArr[13]
            this.transactionForm.endTime = dataArr[1]
            this.getTransactionList()
          }
        } else {
          if(val == 'transaction'){
            this.transactionTime = '1'
            this.transactionForm.startTime = dataArr[14]
            this.transactionForm.endTime = dataArr[2]
            this.getTransactionList()
          } else {
            this.wholeTime = '1'
            this.wholeForm.startTime = dataArr[14]
            this.wholeForm.endTime = dataArr[2]
            this.getWholeList()
            this.transactionTime = '1'
            this.transactionForm.startTime = dataArr[14]
            this.transactionForm.endTime = dataArr[2]
            this.getTransactionList()
          }
        }
      },
      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (val == 'transaction') {
          this.transactionTime = '1'
          if (day > 14) {
            this.transactionForm.endTime = dataArr[1]
          } else {
            this.transactionForm.endTime = dataArr[2]
          }
          this.getTransactionList()
        } else {
          if (day > 14) {
            this.transactionForm.endTime = dataArr[1]
            this.goodsCategoryForm.endTime = dataArr[1]
          } else {
            this.transactionForm.endTime = dataArr[2]
            this.goodsCategoryForm.endTime = dataArr[2]
          }
          this.goodsCategoryTime = '1'
          this.transactionTime = '1'
          this.getGoodsCategory()
          this.getTransactionList()
        }

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //计算最大值
      cityCalMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      cityCalMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
    }
  }
</script>

<style>

  .agricultureProducts-page .el-tabs__nav-wrap {
    border: 1px solid rgba(100, 156, 238, 0.4);
  }

  .agricultureProducts-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
  }

  .agricultureProducts-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .agricultureProducts-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .agricultureProducts-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .agricultureProducts-page .el-form-item {
    margin-bottom: 0;
  }



</style>



// WEBPACK FOOTER //
// src/components/agricultureModel/agricultureProducts.vue